import styled from "styled-components";
import { Text, Div } from "../../StyledComponents";
import { createGlobalStyle } from "styled-components";

export const ModalDailog = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;

  animation: popupScale 0.25s ease-out;

  @keyframes popupScale {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const ModalBody = styled.div`
  width: 520px;
  background: #ffffff;
  border-radius: 10px;
  padding: 16px 18px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.18);
  animation: modalFade 0.2s ease;

  @keyframes modalFade {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.96);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

export const TextVariant = styled(Text)`
  font-size: 16px;
  color: #263446;
  display: block;
  margin: 8px 0px 0px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  @media (max-width: 1440px) {
    font-size: 14px;
  }
`;

export const TextVariant2 = styled(Text)`
  ${(p) => p.width && `width : ${p.width};`}
  font-size : 14px;
  color: #212121;
  text-align: left;
  margin-right: ${({ mr }) => mr && mr};
  ${(p) => p.breakAll && `word-break: break-all;`}

  @media (max-width: 3000px) {
    font-size: 14px;
    margin-right: 6px;
  }
  @media (max-width: 1350px) {
    font-size: 13px;
    margin-right: 6px;
  }
  @media (max-width: 1100px) {
    font-size: 12px;
    margin-right: 6px;
  }
  @media (max-width: 950px) {
    font-size: 10px;
    margin-right: 6px;
  }
`;

export const DivVariant = styled(Div)`
  display: flex;
  padding: 12px 0px 0px 12px;
  border-radius: 6px;

  ${({ type }) =>
    type === "office"
      ? `@media (width: 1440px) {
        padding: 6px 0px 0px 12px;
      }`
      : `@media (width: 1440px) {
        padding: 10px 0px 0px 12px;
      }`}

  @media (width: 1024px) {
    padding: 10px 0px 0px 8px;
  }
`;

export const FlexText = styled.p`
  font-family: "Urbanist";
  font-size: 12px;
  line-height: 18px;
  color: #2e2c34;
  display: flex;
  align-items: center;
`;
export const ModalInput = styled.input`
  width: 100%;
  height: 38px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: #2c7be5;
    box-shadow: 0 0 0 2px rgba(44, 123, 229, 0.15);
  }
`;

export const ModalTextarea = styled.textarea`
  width: 100%;
  height: 72px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 14px;
  resize: none;
  outline: none;

  &:focus {
    border-color: #2c7be5;
    box-shadow: 0 0 0 2px rgba(44, 123, 229, 0.15);
  }
`;

export const AntdSelectWrapper = styled.div`
  .ant-select {
    width: 100%;
  }

  .ant-select-selector {
    height: 38px !important;
    border-radius: 6px !important;
    border: 1px solid #d1d5db !important;
    padding: 0 12px !important;
    box-shadow: none !important;
    display: flex;
    align-items: center;
    font-size: 14px !important;
  }

  .ant-select-selection-placeholder {
    font-size: 14px !important;
    color: #9ca3af !important;
  }

  .ant-select-arrow {
    color: #6b7280 !important;
  }
`;

export const AntdDateWrapper = styled.div`
  .ant-picker {
    width: 100%;
    height: 38px !important;
    border-radius: 6px !important;
    border: 1px solid #d1d5db !important;
    padding: 0 12px !important;
    box-shadow: none !important;
    display: flex;
    align-items: center;
  }

  .ant-picker-input input {
    font-size: 14px !important;
  }

  .ant-picker-suffix {
    color: #6b7280 !important;
  }
`;

export const SmallDatePickerStyle = createGlobalStyle`
  /* Only DatePicker inside appointment modal */

  .appointment-modal .ant-picker-panel {
    font-size: 12px;
  }

  .appointment-modal .ant-picker-content th,
  .appointment-modal .ant-picker-content td {
    width: 26px;
    height: 26px;
  }

  .appointment-modal .ant-picker-cell {
    padding: 2px 0;
  }
`;

export const ModalScrollWrapper = styled.div`
  width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  padding-right: 6px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
`;
